/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgentContextDocumentUpsertRequest } from '../../models/agent-context-document-upsert-request';
import { ApiResponseAgentContextDocumentDto } from '../../models/api-response-agent-context-document-dto';

export interface UpsertContextDocument$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  companyId: string;
  documentType: string;
      body: AgentContextDocumentUpsertRequest
}

export function upsertContextDocument(http: HttpClient, rootUrl: string, params: UpsertContextDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAgentContextDocumentDto>> {
  const rb = new RequestBuilder(rootUrl, upsertContextDocument.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('companyId', params.companyId, {});
    rb.path('documentType', params.documentType, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseAgentContextDocumentDto>;
    })
  );
}

upsertContextDocument.PATH = '/v1/api/admin-ui/agent-context/{companyId}/documents/{documentType}';
